import {
	ShareBaseDocument,
	ShareBaseFolder
} from 'phoenix/domain';
import { AuthService } from 'phoenix/services';
import { FolderDataStore } from '../dataStores/folderDataStore';

interface DocumentStateParams {
	route:string
	options:DocumentOptions
}

interface DocumentOptions {
	docID:number,
	token?:string,
	password?:string,
	recipient?:string
}

export type IDocumentNavigationService = DocumentNavigationService;

export class DocumentNavigationService {
	public static $inject = [
		'$q',
		'$state',
		'$stateParams',
		'pxAuthService',
		'sbaFolderDataStore',
	]

	folder:ShareBaseFolder;
	documents:ShareBaseDocument[] = [];
	currentPosition:number = -1;

	constructor(
		private readonly $q:ng.IQService,
		private readonly $state,
		private readonly $stateParams,
		private readonly pxAuthService:AuthService,
		private readonly sbaFolderDataStore:FolderDataStore
	) {		

	}

	public setFolder(folderDS:FolderDataStore) {
		this.currentPosition = 0;
		this.folder = folderDS.folder;
		this.documents = angular.copy(folderDS.documents);
	}
	
	public next(){
		if(!this.documents){return;}
		let params = this.getStateParams();
		let index = this.currentPosition >= this.documents.length - 1 ? 0 : this.currentPosition + 1;
		params.options.docID = this.documents[index].DocumentId;
		this.$state.go(params.route, params.options);
	}
	
	public previous(){
		if(!this.documents){return;}
		let params = this.getStateParams();
		let index = this.currentPosition === 0 ? this.documents.length - 1 : this.currentPosition - 1;
		params.options.docID = this.documents[index].DocumentId;
		this.$state.go(params.route, params.options);
	}
	
	public setContext(document:ShareBaseDocument){
		let navQ = this.$q.resolve();;
		let path =  document.Embedded.Path || [];
		let navFolderId = this.folder ? this.folder.FolderId : null;		
		let docParentFolderId = path.length > 0 ? path[path.length - 1].FolderId : null;
		
		if(!angular.isNumber(docParentFolderId)){
			return;
		}
		
		let folderInMemory = angular.isNumber(navFolderId) && navFolderId === docParentFolderId;
		if(!folderInMemory){
			navQ = this.sbaFolderDataStore
				.load(docParentFolderId, true)
				.then(() => {
					this.setFolder(this.sbaFolderDataStore);
				});
			}		

			navQ
			.finally(() => {
				//get current index of active document
				this.setNavigationIndex(document.DocumentId);					
			});
	}
	
	get canNavigate():boolean{
		return this.currentPosition > -1 && this.documents.length>1;
	}
	
	private getStateParams() {
		let params:DocumentStateParams = {
			route: 'content.myFiles.document',
			options: { docID: null }
		};

		if (this.pxAuthService.isShareByLinkUser) {
			params.route += '.share';
			params.options = angular.extend(params.options, {
				token: this.$stateParams.token,
				password: this.$stateParams.password,
				recipient: this.$stateParams.recipient
			});
		}
		return params;
	}

	private setNavigationIndex(documentId:number){
		let found = -1;
		this.documents.forEach((doc, index) => {
			if(doc.DocumentId === documentId) {
				found = index;				
			}
		});
		this.currentPosition = found;
	}

}


// WEBPACK FOOTER //
// ./src/sharebase-app/services/documentNavigationService.ts